import { Grid } from '@mui/material'
import { LabeledText, TitledSection } from '../../../../components'
import { MembershipFeesQueryType } from '../../../../types'
import { BankAccount } from '../../../../utils/classes/graphql'
import { usePaymentInfo } from '../contexts'
import { VirtualBarCode } from './virtual-bar-code'

interface MembershipFeePaymentInfoProps {
  bankAccounts: MembershipFeesQueryType['bankAccounts']
}

export const MembershipFeePaymentInfo = ({
  bankAccounts
}: MembershipFeePaymentInfoProps) => {
  const { paymentInfo } = usePaymentInfo()

  if (!paymentInfo) {
    return null
  }

  const accountNamesAndNumbers = bankAccounts.map((item: BankAccount) => {
    return item.konttori + ' ' + item.iban
  })

  return (
    <TitledSection translationid="pages.membershipFeesPage.calculateMembershipFeePage.paymentInfo">
      <Grid container spacing={2}>
        <Grid item md={4} xs={12}>
          <LabeledText
            labelTranslationId="pages.membershipFeesPage.calculateMembershipFeePage.bankAccount"
            texts={accountNamesAndNumbers}
            defaultText="-"
          />
        </Grid>
        <Grid item md={true} xs={12}>
          <LabeledText
            labelTranslationId="pages.membershipFeesPage.paymentInformation.paymentRecipient"
            textTranslationIds={['contact.address.postName']}
          />
        </Grid>
        <Grid item md={12} xs={12}>
          <LabeledText
            labelTranslationId="pages.membershipFeesPage.calculateMembershipFeePage.paymentAmount"
            texts={[paymentInfo.amount]}
          />
        </Grid>
        <Grid item md={12} xs={12}>
          <VirtualBarCode virtualBarCode={paymentInfo.virtualBarCode} />
        </Grid>
        <Grid item md={6} xs={12}>
          <LabeledText
            id="reference"
            labelTranslationId="pages.membershipFeesPage.calculateMembershipFeePage.reference"
            texts={[paymentInfo.reference]}
          />
        </Grid>
        <Grid item md={true} xs={12}>
          <LabeledText
            labelTranslationId="pages.membershipFeesPage.calculateMembershipFeePage.dueDate"
            texts={[paymentInfo.dueDate]}
          />
        </Grid>
      </Grid>
    </TitledSection>
  )
}
